import StreamConversation from 'global/StreamConversation';
import Post from 'global/StreamWidget/Post';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectors as streamSelectors } from 'global/StreamWidget/slice';
import { effects, selectors } from '../slice';
import { PinnedPostContainer } from '../styled';

interface PinnedPostProps {
  username: string;
}

function PinnedPost({ username }: PinnedPostProps) {
  const dispatch = useDispatch();
  const {
    pinnedPost: { data: pinnedPost },
  } = useSelector(selectors);
  const { togglePinPost } = useSelector(streamSelectors);

  // state
  const [showConvo, setShowConvo] = useState<boolean>(false);
  const [selectedPostId, setSelectedPostId] = useState(null);
  const [selectedParentId, setSelectedParentId] = useState(null);

  useEffect(() => {
    const hasPinnedPost =
      username || (togglePinPost.data && !togglePinPost.error);
    if (hasPinnedPost) {
      dispatch(effects.getPinnedPost({ username }));
    }
  }, [dispatch, username, togglePinPost.data]);

  const handleOpenConvo = (post) => {
    setSelectedPostId(post?.postid);
    setSelectedParentId(post?.parent_postid);
  };

  const handleCloseConvo = () => {
    setShowConvo(false);
    setSelectedPostId(null);
  };

  if (!pinnedPost[username]) {
    return <div />;
  }

  return (
    <>
      <PinnedPostContainer>
        <Post
          post={pinnedPost[username]}
          onComment={() => handleOpenConvo(pinnedPost[username])}
          pinned
          hasFollowingActivity={false}
          entryPoint="user"
        />
      </PinnedPostContainer>
      <StreamConversation
        visible={showConvo}
        onCancel={handleCloseConvo}
        postId={selectedPostId}
        parentId={selectedParentId}
        activeCommentId={selectedPostId}
        destroyOnClose
        openConversation={() => setShowConvo(true)}
      />
    </>
  );
}

export default PinnedPost;
